import { Button, Form, FormProps, Input } from "antd";
import { useIntl, FormattedMessage } from "react-intl";
import DatePickerField from "components/fields/DatePickerField";
import { useMatch } from "react-router-dom";
import { ROUTE_PATHS } from "const/paths";

import * as Styled from "../../styles";

import { presalePasswordsFormLayout } from "./consts";
import { PresalePasswordsFormValue, PresalePasswordsFormProps } from "./types";

const PresalePasswordsForm: React.FC<PresalePasswordsFormProps> = ({
  editValues,
  onSubmit,
  onClose,
}) => {
  const intl = useIntl();
  const isEditRoute = !!useMatch(ROUTE_PATHS.EventEdit);

  const onFinish: FormProps<PresalePasswordsFormValue>["onFinish"] = (
    values
  ) => {
    onSubmit(values);
    onClose();
  };

  const onFinishFailed: FormProps<PresalePasswordsFormValue>["onFinishFailed"] =
    () => {
      onClose();
    };

  return (
    <Form
      layout="vertical"
      initialValues={editValues || {}}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
      {...{ presalePasswordsFormLayout }}
    >
      <Form.Item
        label={<FormattedMessage defaultMessage="Name" />}
        name="name"
        required
      >
        <Input disabled={isEditRoute ? false : undefined} />
      </Form.Item>
      <Form.Item
        label={<FormattedMessage defaultMessage="Password" />}
        name="password"
        required
      >
        <Input disabled={isEditRoute ? false : undefined} />
      </Form.Item>
      <Form.Item
        label={intl.formatMessage({
          defaultMessage: "Expiration date",
        })}
        name="expireAt"
        required
      >
        <DatePickerField
          utc
          showTime
          disabled={isEditRoute ? false : undefined}
        />
      </Form.Item>
      <Styled.ControlButtonsRow>
        <Button
          disabled={false}
          type="ghost"
          onClick={() => {
            onClose();
          }}
        >
          <FormattedMessage defaultMessage="Cancel" />
        </Button>
        <Form.Item style={{ marginBottom: 0 }}>
          <Button
            htmlType="submit"
            type="primary"
            disabled={isEditRoute ? false : undefined}
          >
            <FormattedMessage defaultMessage="Confirm" />
          </Button>
        </Form.Item>
      </Styled.ControlButtonsRow>
    </Form>
  );
};

export default PresalePasswordsForm;
